import { ReactElement, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '../../i18n';
import MaintenanceMode from '../../views/maintenance-mode';

interface InitializeAppProps {
  children: ReactElement | null;
}

const DEFAULT_LOCALE = 'ar';
const VALID_LOCALES = ['ar', 'en'];

function InitializeApp({ children }: InitializeAppProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMaintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    const handleMaintenanceMode = () => {
      setMaintenanceMode(true);
    };
    window.addEventListener('maintenanceMode', handleMaintenanceMode);
    return () => {
      window.removeEventListener('maintenanceMode', handleMaintenanceMode);
    };
  }, []);

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const localeFromPath = pathSegments[0];

    if (!VALID_LOCALES.includes(localeFromPath)) {
      const newPath = `/${DEFAULT_LOCALE}${location.pathname}`;
      navigate(newPath, { replace: true });
    } else if (i18n.resolvedLanguage !== localeFromPath) {
      if (i18n.options.fallbackLng) {
        i18n.changeLanguage(localeFromPath);
        document.documentElement.lang = localeFromPath;
        const direction = localeFromPath === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.dir = direction;
      }
    }
  }, [navigate, location]);

  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return children;
}

export default InitializeApp;
